import { jsx } from "react/jsx-runtime";
import { c as ce } from "./Grid-CcQKdsgp.js";
import { F as Flex } from "./Flex-BqkSIn_m.js";
const cardStyles = ce({
  base: "",
  variants: {
    variant: {
      primary: "md:bg-[var(--colors-text-disabled)] border-0 md:border md:border-[var(--colors-border-subtle)]",
      secondary: "bg-[var(--colors-surface-primary-dark)] shadow-[0px_0px_44px_0px_var(--colors-surface-neutral-dark-default)] backdrop-blur-[32px] border border-[var(--colors-border-selected)] ",
      tertiary: "bg-gradient-to-b from-[var(--colors-surface-primary-dark)] to-[var(--colors-surface-primary-dark)] items-center",
      default: ""
    }
  },
  defaultVariants: {
    variant: "primary"
  }
});
const Card = (props) => {
  const {
    className = "",
    children,
    variant,
    as = "div",
    flexDirection = "column",
    border = { radius: "card" }
  } = props;
  return /* @__PURE__ */ jsx(
    Flex,
    {
      ...props,
      as,
      flexDirection,
      className: cardStyles({ variant, className }),
      border,
      children
    }
  );
};
export {
  Card as C
};
